module.exports=React;